import React from 'react';

const BackgroundPattern = ({ position = 'right', top = '50%', opacity = 0.04 }) => {
  const isRight = position === 'right';
  
  return (
    <div 
      className={`position-absolute d-none d-lg-block z-0 ${isRight ? 'end-0' : 'start-0'}`} 
      style={{ 
        top: top,
        transform: 'translateY(-50%)',
        opacity: opacity, 
        pointerEvents: 'none',
        overflow: 'hidden'
      }}
    >
      <svg width="450" height="600" viewBox="0 0 240 320" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Outer Chevron */}
        <path d="M120 20 L220 120 V320 M120 20 L20 120 V320" stroke="#061830" strokeWidth="3" />
        {/* Middle Chevron */}
        <path d="M120 80 L180 140 V320 M120 80 L60 140 V320" stroke="#061830" strokeWidth="3" />
        {/* Inner Chevron / Pillar */}
        <path d="M120 140 L150 170 V320 M120 140 L90 170 V320" stroke="#061830" strokeWidth="3" />
        <path d="M120 200 V320" stroke="#061830" strokeWidth="3" />
      </svg>
    </div>
  );
};

export default BackgroundPattern;
